<template>
	<div class="base-div">
		<!-- <ul class="task-ul clearfix">
            <li><img src="../../../assets/task_icon_01.png" @click="changeTab(1)"/></li>
			<li><img src="../../../assets/task_icon_02.png" @click="changeTab(2)"/></li>
			<li><img src="../../../assets/task_icon_03.png" @click="changeTab(3)"/></li>
			<li><img src="../../../assets/task_icon_04.png" @click="changeTab(4)"/></li>
		</ul> -->
		<ul class="task-ul clearfix">
			<li>
				<router-link to="/home/task/tasklist/1"></router-link>
			</li>
			<li>
				<router-link to="/home/task/tasklist/2"></router-link>
			</li>
			<li>
				<router-link to="/home/task/tasklist/3"></router-link>
			</li>
			<li>
				<router-link to="/home/task/problem"></router-link>
			</li>
		</ul>
		<div class="task clearfix">
			<div class="task-l">
				<router-view />
			</div>
			<div class="task-r" v-if="rankTypeList.length>0">
				<div v-for="item in rankTypeList" :key="item.id">
					<img class="swiper-item-title" v-if="rankTypeId==item.id" :src="item.fileUrl" />
				</div>
				<ul class="nav">
					<li :class="{'active': currentIndex==index}" @click="navChange(index)"
						v-for="(item,index) in navList" :key="index">
						<span class="nav-item">{{item}}</span>
						<span class="line">|</span>
					</li>
				</ul>
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<!-- 每个节点 -->
						<div class="swiper-slide" v-for="itemRank in rankTypeList" :key="itemRank.id">
							<ul class="ranking-ul" :ref="'ranking'+activeIndex" v-if="rankingFlag==1&&dataList.length>0">
								<li class="clearfix" v-for="(item,index) in dataList" :key="'index-' + index">
									<span class="ranking-num">{{item.rank}}</span>
									<div class="avator-wrap" v-if="index<5" :title="item.realName">
										<img class="avatar"
											:src="item.headPic?item.headPic:require('../../../assets/default_avatar.png')" />
									</div>
									<div class="avator-wrap" v-else>
										<img class="avatar"
											:src="item.headPic?item.headPic:require('../../../assets/default_avatar.png')" />
									</div>
									<div class="ranking-list-r">
										<span class="email">{{item.mail}}</span>
										<span class="score">{{item.integralNum}}分</span>
									</div>
								</li>
							</ul>
							<ul class="ranking-ul" v-else>
								<li class="empty">敬请期待...</li>
							</ul>
						</div>
					</div>
					<div class="ranking-btn" @click="getMoreData">
						<span>{{moreLoadTxt}}</span>
						<img v-if="isLastPage==0&&pageNum<10" src="../../../assets/arrow_down.png" />
					</div>
				</div>
			</div>
			<div class="task-r" v-else>
				<ul class="ranking-ul">
					<li class="empty">敬请期待...</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import Swiper from "swiper"
	import 'swiper/dist/css/swiper.css'
	import qs from 'qs'
	import {
		post,
		ajaxParam
	} from '../../../units/request.js'
	export default {
		name: '',
		components: {
			//swiper
		},
		data() {
			return {
				fullPath: '', //当前页面路径
				pageNum: 1,
				pageSize: 10,
				dataList: [],
				isLastPage: 0,
				rankingType: '',
				rankTypeId: '',
				moreLoadTxt: '查看更多排名',
				rankingFlag: 1,
				navList: ['综合', '适配', '测试'],
				currentIndex: 0,
				pointType: 0, //积分类型0综合 1适配  2测试
				activityType: 1,
				rankTypeList:[],
				activeIndex: 0
			}
		},
		mounted() {
			setTimeout(()=>{
				this.initSwiper()
			},300)
		},
		methods: {
			//获取排行榜类型
			async getRankType(){
				let url = 'v1/integral/getIntegralRankingType'
				let param = {
					activityId: this.activityId
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if (res.data.code == 200) {
					this.rankTypeList =res.data.list
					if(this.rankTypeList.length>0) {
						this.rankTypeId = this.rankTypeList[0].id
						this.getDataList()
					}
				} else {
					this.$message.error(res.data.msg)
				}
			},
			navChange(index) {
				this.currentIndex = index
				if(this.activityType==2) {
					this.pointType = index+1
				} else if(this.activityType==1) {
					this.pointType = index
				}
				this.rankingFlag = 1
				this.moreLoadTxt = '查看更多排名'
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			initSwiper() {
				var that = this
				new Swiper(".swiper-container", {
					//设置轮播的循环方式
					//loop: true,

					//设置自动播放间隔时间
					autoplay: false,

					// 轮播效果,默认为平滑轮播
					effect: "slide",

					//前进后退按钮
					prevButton: ".swiper-button-prev",
					nextButton: ".swiper-button-next",

					// 用户中断轮播后续播
					autoplayDisableOnInteraction: false,
					onSlideChangeStart: function(swiper) {
						that.rankTypeId = that.rankTypeList[swiper.activeIndex].id
						that.activeIndex = swiper.activeIndex
						that.rankingFlag = 1
						that.dataList = []
						that.pageNum = 1
						that.moreLoadTxt = '查看更多排名'
						that.getDataList()
					}
				});
			},
			//获取积分排行
			async getDataList() {
				let url = 'v1/integral/getIntegralRanking'
				let param = {
					activityId: this.activityId,
					rankingTypeId: this.rankTypeId,
					pointType: this.pointType,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				let dataList = this.dataList
				if (this.pageNum == 1) {
					dataList = []
				}
				res.data.list.forEach(item => {
					dataList.push(item)
				})
				this.dataList = dataList
				this.isLastPage = res.data.isLastPage
				this.rankingFlag = res.data.rankingFlag
				if (this.isLastPage == 1 || this.pageNum >= 10) {
					this.moreLoadTxt = '没有更多内容了'
				}
			},
			//获取更多积分排行
			getMoreData() {
				if (this.isLastPage != 1 && this.pageNum < 10) {
					this.pageNum++
					this.getDataList().then(() => {
						this.$nextTick(() => {
							this.$refs[`ranking${this.activeIndex}`][this.activeIndex].scrollTop = this.$refs[`ranking${this.activeIndex}`][this.activeIndex].scrollHeight
							//this.$refs.ranking1.scrollTop = this.$refs.ranking1.scrollHeight
						})
					})
				}
			},
			changeTab(index) {
				if (index == 1) {
					this.$router.push('/task/tasklist')
				}
				if (index == 4) {
					this.$router.push('/task/problem')
				}
			},
		},
		created() {
			//console.log(this.$route.fullPath)
			this.fullPath = this.$route.fullPath
			this.activityType = localStorage.getItem('activityType')
			this.activityId = localStorage.getItem('activityId')
			if (this.activityType == 2) {
				this.pointType = 1
				this.navList =['适配', '测试']
			}
			this.getRankType()
		}
	}
</script>
<style scoped>
	.task-ul li {
		float: left;
		width: 21.25%;
		height: 138px;
		margin-right: 5%;
	}

	.task-ul li a {
		display: block;
		width: 100%;
		height: 100%
	}

	.task-ul li:nth-of-type(1) a {
		background: url('../../../assets/task_icon_01.png') no-repeat;
		background-size: 100% 100%;
	}

	.task-ul li:nth-of-type(2) a {
		background: url('../../../assets/task_icon_02.png') no-repeat;
		background-size: 100% 100%;
	}

	.task-ul li:nth-of-type(3) a {
		background: url('../../../assets/task_icon_03.png') no-repeat;
		background-size: 100% 100%;
	}

	.task-ul li:nth-of-type(4) a {
		background: url('../../../assets/task_icon_04.png') no-repeat;
		background-size: 100% 100%;
	}

	.task-ul li:nth-of-type(1) a.router-link-active {
		background: url('../../../assets/task_iconh_01.png') no-repeat;
		background-size: 100% 100%;
	}

	.task-ul li:nth-of-type(2) a.router-link-active {
		background: url('../../../assets/task_iconh_02.png') no-repeat;
		background-size: 100% 100%;
	}

	.task-ul li:nth-of-type(3) a.router-link-active {
		background: url('../../../assets/task_iconh_03.png') no-repeat;
		background-size: 100% 100%;
	}

	.task-ul li:nth-of-type(4) a.router-link-active {
		background: url('../../../assets/task_iconh_04.png') no-repeat;
		background-size: 100% 100%;
	}

	.task-ul li:last-of-type {
		margin-right: 0
	}

	.task-ul li img {
		width: 100%
	}

	.task {
		margin-top: 40px
	}

	.task-l {
		float: left;
		width: 73.75%;
		min-height: 720px;
		padding-bottom: 20px;
		/* background:#f4f4f4 */
	}

	.task-r {
		float: right;
		width: 21.25%;
		border: 1px solid #e6e6e6;
		box-sizing: border-box;
		position: relative
	}

	.swiper-container {}

	.swiper-container h3 {
		padding: 15px 0 20px;
		font-size: 20px;
		line-height: 37px;
		text-align: center;
	}

	.swiper-item-title {
		display: block;
		width: 150px;
		height: 21px;
		margin: 18px auto 10px;
	}

	.ranking-ul {
		height: 550px;
		overflow: auto;
	}

	.ranking-ul li {
		margin-bottom: 15px;
	}

	.ranking-num {
		float: left;
		width: 15%;
		height: 40px;
		text-align: center;
		line-height: 40px;
		font-weight: bold;
		font-size: 20px;
	}

	.ranking-ul li:nth-of-type(1) .ranking-num,
	.ranking-ul li:nth-of-type(2) .ranking-num,
	.ranking-ul li:nth-of-type(3) .ranking-num {
		color: #F3DE9D;
	}

	.ranking-ul li:nth-of-type(2) .ranking-num {
		color: #ECECEC;
	}

	.ranking-ul li:nth-of-type(3) .ranking-num {
		color: #E2C19E;
	}

	.avator-wrap {
		float: left;
		width: 40px;
		height: 40px;
		margin-right: 15px
	}

	.avator-wrap img {
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin: 0 5px
	}

	/* .ranking-ul li:nth-of-type(1) .avator-wrap,.ranking-ul li:nth-of-type(2) .avator-wrap,.ranking-ul li:nth-of-type(3) .avator-wrap{width: 50px; height: 50px;margin-left:0; margin-right:10px}
.ranking-ul li:nth-of-type(1) .avator-wrap img,.ranking-ul li:nth-of-type(2) .avator-wrap img,.ranking-ul li:nth-of-type(3) .avator-wrap img{width:50px; height:50px; margin:0} */
	.ranking-list-r {
		float: left;
		width: 51%
	}

	/* .ranking-ul li:nth-of-type(1) .ranking-list-r span,.ranking-ul li:nth-of-type(2) .ranking-list-r span,.ranking-ul li:nth-of-type(3) .ranking-list-r span{line-height: 28px;} */
	.ranking-list-r span {
		display: block;
		line-height: 20px;
		white-space: nowrap;
		overflow: hidden;
	}

	.score {
		color: #DE0515
	}

	/* .ranking-ul li:nth-of-type(1) .score,.ranking-ul li:nth-of-type(2) .score,.ranking-ul li:nth-of-type(3) .score{font-size: 20px;} */
	.email {
		font-size: 10px;
	}

	/* .ranking-ul li:nth-of-type(1) .email,.ranking-ul li:nth-of-type(2) .email,.ranking-ul li:nth-of-type(3) .email{font-size: 12px;} */
	.ranking-btn {
		padding-bottom: 10px;
		color: #0DA5F3;
		text-align: center;
		cursor: pointer;
		font-size: 13px;
	}

	.ranking-btn span {
		display: block;
	}

	.ranking-btn img {
		display: block;
		width: 16px;
		height: 8px;
		margin: 5px auto 0
	}

	.swiper-button-prev,
	.swiper-button-next {
		top: 45px;
		width: 10px;
		height: 10px;
		background-size: 10px 10px;
		background-image: url("../../../assets/arrow_right.png");
	}

	.swiper-button-prev {
		background-image: url("../../../assets/arrow_left.png");
	}

	.swiper-button-next {
		right: 20px
	}

	.swiper-button-prev {
		left: 20px
	}

	.empty {
		padding-top: 30px;
		text-align: center;
		font-size: 16px;
		color: #bebebe;
		letter-spacing: 2px;
	}

	.nav {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 18px;
		color: #1BAAF3
	}

	.nav li {
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.nav-item {}

	.nav li .line {
		padding: 0 10px
	}

	.nav li.active {
		font-weight: bold;
		font-size: 16px;
	}

	.nav li.active .line {
		font-weight: normal;
		font-size: 14px;
	}

	.nav li:last-of-type .line {
		display: none;
	}
</style>
